(function () {
  let flashTimer = null;
  let isAlt = false;
  let currentPageTitle = document.title;

  function startFlashingTitle() {
    if (flashTimer) return;

    // Capture the REAL current page title when user leaves
    currentPageTitle = document.title;

    flashTimer = setInterval(() => {
      document.title = isAlt ? currentPageTitle : "Leaving so soon?";
      isAlt = !isAlt;
    }, 900);
  }

  function stopFlashingTitle() {
    clearInterval(flashTimer);
    flashTimer = null;

    // Restore to the actual page title
    document.title = currentPageTitle;
  }

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      startFlashingTitle();
    } else {
      stopFlashingTitle();
    }
  });
})();
